<template>
  <div class="anpr-filters">
    <div class="d-flex e-gap-2">
      <div class="mr-3">
        <span class="font-weight-500"> Plate </span>

        <v-text-field
          v-model="anprStore.plateNumber"
          hide-details
          outlined
          label="Search plate number"
          dense
        ></v-text-field>
      </div>
      <div class="mr-3">
        <span class="font-weight-500"> Direction </span>
        <EToggleSwitch
          v-model="anprStore.direction"
          :options="directionOptions"
          :size="Size.Md"
          color="primary"
        />
      </div>
      <div class="d-flex flex-column">
        <v-switch
          v-model="anprStore.showDuplicates"
          small
          dense
          inset
          label="Duplicates"
          :disabled="!anprStore.showPostProcessed"
          hide-details
          @change="onNonExclusiveFilterToggle"
        />
        <v-switch
          v-model="anprStore.showFalsePositives"
          class="ma-0 pa-0"
          small
          dense
          inset
          label="False Positives"
          :disabled="!anprStore.showPostProcessed"
          hide-details
          @change="onNonExclusiveFilterToggle"
        />
      </div>
      <div class="d-flex flex-column">
        <v-switch
          v-model="anprStore.showOnlyDuplicates"
          small
          dense
          inset
          label="Only Duplicates"
          :disabled="!anprStore.showPostProcessed"
          hide-details
          @change="onShowOnlyDuplicatesToggle"
        />
        <v-switch
          v-model="anprStore.showOnlyFalsePositives"
          class="ma-0 pa-0"
          small
          dense
          inset
          label="Only False Positives"
          :disabled="!anprStore.showPostProcessed"
          hide-details
          @change="onShowOnlyFalsePositivesToggle"
        />
      </div>
      <div class="d-flex flex-column ml-2">
        <v-tooltip bottom max-width="200">
          <template #activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-switch
                v-model="anprStore.showNotPostProcessed"
                small
                dense
                inset
                label="Not postprocessed"
                hide-details
              />
            </div>
          </template>
          <span
            >Events that were not post-processed due to video not being recorded
            or other failures.</span
          >
        </v-tooltip>
        <v-switch
          v-model="anprStore.showPostProcessed"
          class="ma-0 pa-0"
          small
          dense
          inset
          label="Postprocessed"
          hide-details
        />
      </div>
    </div>
    <div class="d-flex">
      <ChipsToggleFilter
        v-model="anprStore.selectedVehicleTypes"
        title="Truck types"
        :items="anprStore.vehicleTypes"
        all-label="All trucks"
        :item-key="(item) => item.value"
        :item-label="(item) => item.label"
        class="ma-0"
      />
      <ChipsToggleFilter
        v-model="anprStore.selectedCameraExids"
        title="Cameras"
        :items="anprCameras"
        all-label="All Cameras"
        :item-key="(item) => item.exid"
        :item-label="(item) => item.name"
        class="ma-0"
      />
    </div>
  </div>
</template>

<script>
import { AnprDirection, CameraFeatureFlag } from "@evercam/shared/types"
import ChipsToggleFilter from "@evercam/shared/components/ChipsToggleFilter"
import { useAnprStore } from "@/stores/anpr"
import { mapStores } from "pinia"
import { Size } from "@evercam/ui"
export default {
  components: {
    ChipsToggleFilter,
  },
  data() {
    return {
      directionOptions: [
        { label: "All", value: null },
        { label: "In", value: AnprDirection.Arrived },
        { label: "Out", value: AnprDirection.Left },
        { label: "Unknown", value: AnprDirection.Unknown },
      ],
      Size,
    }
  },
  computed: {
    ...mapStores(useAnprStore),
    anprCameras() {
      return this.anprStore.cameras.filter((camera) =>
        camera.featureFlags.includes(CameraFeatureFlag.ANPR)
      )
    },
  },
  watch: {
    "anprStore.selectedCameraExids": {
      handler() {
        this.anprStore.fetchDailyCounts()
      },
      deep: true,
    },
  },
  methods: {
    onShowOnlyDuplicatesToggle() {
      if (this.anprStore.showOnlyDuplicates) {
        this.anprStore.showOnlyFalsePositives = false
        this.anprStore.showDuplicates = false
        this.anprStore.showFalsePositives = false
      }
    },
    onShowOnlyFalsePositivesToggle() {
      if (this.anprStore.showOnlyFalsePositives) {
        this.anprStore.showOnlyDuplicates = false
        this.anprStore.showDuplicates = false
        this.anprStore.showFalsePositives = false
      }
    },
    onNonExclusiveFilterToggle() {
      if (this.anprStore.showDuplicates || this.anprStore.showFalsePositives) {
        this.anprStore.showOnlyDuplicates = false
        this.anprStore.showOnlyFalsePositives = false
      }
    },
  },
}
</script>

<style lang="scss">
.anpr-filters {
  .v-input--switch label {
    line-height: 12px;
  }

  .v-input--selection-controls__input {
    width: 40px;
  }
}
</style>
